'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _Memoize = require('../core/Memoize');

var _SafePureComponent2 = require('../core/SafePureComponent');

var _SafePureComponent3 = _interopRequireDefault(_SafePureComponent2);

var _MeasureText = require('../utils/MeasureText');

var _Fonts = require('../utils/Fonts');

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _UITextArea = require('./UITextArea');

var _UITextArea2 = _interopRequireDefault(_UITextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getStyle = function getStyle(style, height, maxHeight) {
  return _extends({}, style, {
    height: height,
    maxHeight: maxHeight === Infinity ? null : maxHeight,
    overflow: height > maxHeight ? 'auto' : 'hidden'
  });
};

var UIExpandingTextArea = function (_SafePureComponent) {
  _inherits(UIExpandingTextArea, _SafePureComponent);

  function UIExpandingTextArea(props) {
    _classCallCheck(this, UIExpandingTextArea);

    var _this = _possibleConstructorReturn(this, (UIExpandingTextArea.__proto__ || Object.getPrototypeOf(UIExpandingTextArea)).call(this, props));

    _this.state = {
      height: null
    };
    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this.setHeight = _this.setHeight.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    return _this;
  }

  _createClass(UIExpandingTextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setHeight(true);
      window.addEventListener('resize', this.handleWindowResize);
      if (!(0, _Fonts.fontsLoaded)()) _Fonts.fontsLoadedPromise.then(this.setHeight);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.height === this.state.height) {
        this.setHeight();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.cancelAnimationFrame(this._frame);
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      window.cancelAnimationFrame(this._frame);
      this._frame = window.requestAnimationFrame(this.setHeight);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(evt) {
      this.setHeight();
      var onChange = this.props.onChange;

      (0, _Functions.callIfPossible)(onChange, evt);
    }
  }, {
    key: 'setHeight',
    value: function setHeight() {
      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _props = this.props,
          inputRef = _props.inputRef,
          minHeight = _props.minHeight,
          shrink = _props.shrink;

      if (!inputRef) return;
      var textAreaNode = inputRef.current;
      if (!textAreaNode) return;

      var textHeight = (0, _MeasureText.getTextHeight)(textAreaNode);
      var newHeight = void 0;
      if (shrink) {
        newHeight = Math.max(minHeight, textHeight);
      } else {
        // Ensure that we don't reduce height below what the user set by manually resizing
        var measuredHeight = initial ? 0 : textAreaNode.getBoundingClientRect().height;
        newHeight = Math.max(minHeight, textHeight, measuredHeight);
      }
      if (this.state.height !== newHeight) {
        this.setState({ height: newHeight });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          maxHeight = _props2.maxHeight,
          __minHeight = _props2.minHeight,
          __onChange = _props2.onChange,
          resize = _props2.resize,
          shrink = _props2.shrink,
          style = _props2.style,
          rest = _objectWithoutProperties(_props2, ['maxHeight', 'minHeight', 'onChange', 'resize', 'shrink', 'style']);

      var height = this.state.height;


      return _react2.default.createElement(_UITextArea2.default, _extends({}, rest, {
        _textAreaHeightStyle: this._getStyle(style, height, maxHeight),
        onChange: this.handleChange,
        resize: shrink ? false : resize
      }));
    }
  }]);

  return UIExpandingTextArea;
}(_SafePureComponent3.default);

UIExpandingTextArea.propTypes = _extends({}, _UITextArea2.default.propTypes, {
  maxHeight: _react.PropTypes.number.isRequired,
  minHeight: _react.PropTypes.number.isRequired,
  shrink: _react.PropTypes.bool.isRequired
});

UIExpandingTextArea.defaultProps = _extends({}, _UITextArea2.default.defaultProps, {
  maxHeight: Infinity,
  minHeight: 0,
  shrink: false
});

exports.default = (0, _ShareInput2.default)(UIExpandingTextArea);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/input/UIExpandingTextArea.js
// module id = 1154
// module chunks = 2 3